<template>
	<v-layout row wrap>
		<v-flex d-flex xs5>
			<v-card color="blue" class="white--text">
				<v-card-text style="padding-right: 8px"><strong>Rodzaj kosztu</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card color="blue" class="white--text">
				<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>Rodzaj
					miary</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card color="blue" class="white--text">
				<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center">
					<strong>
						Koszt jednostkowy
					</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card color="blue" class="white--text">
				<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>Liczba
					jednostek</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card color="blue" class="white--text">
				<v-card-text style="padding-left: 8px; padding-right: 8px; text-align: center"><strong>Źródło
					finansowania</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card color="blue" class="white--text">
				<v-card-text><strong>Razem</strong></v-card-text>
			</v-card>
		</v-flex>

	</v-layout>
</template>
<script>
	export default {
		name: "costsHeaders",
	};
</script>
